// src/pages/MyPage/CancelUser.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFixedLayout } from '../../../hooks/useFixedLayout';
import { HeaderIconL } from '../../../assets/components/HeaderGroup';
import left from "../../../assets/icons/Arrow/left.svg"
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import cry from "../../../assets/icons/Cancel/Cry.svg"
import { useLocation } from "react-router-dom";
import checkOn from "../../../assets/icons/Select/check_checked.svg";
import checkOff from "../../../assets/icons/Select/check_unchecked.svg";

const CancelUser = () => {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const location = useLocation();
  const ticketInfo = location.state?.ticketInfo;
  const storeBusinessNumber = location.state?.storeBusinessNumber;

  const tokenAmount = useState(ticketInfo?.token_amount ?? 0);

  // 상하단 고정 훅
  const { headerRef, headerSpace } = useFixedLayout();

  const handleBack = () => {
    navigate("/ads/main", { state: { storeBusinessNumber: storeBusinessNumber, tab: "mypage" } });
  };

  const handleLeave = () => {
    navigate("/cancel/reason");
  };

  const headerTitle = "회원 탈퇴"

  return (
    <div className="flex flex-col min-h-dvh bg-surface-default">

      {/* 헤더 */}
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
        <HeaderIconL
          className=""
          title={headerTitle}
          icon={left}
          onIconClick={handleBack}
        />
      </div>

      <div
        className="px-[16px]"
        style={{ paddingTop: headerSpace }}
      >
        {/* 상단 경고 문구 */}
        <section className="text-center pt-[32px]">
          <p className="text-b1 text-text-subtle">탈퇴하시면</p>
          <p className="text-t4 text-text-danger">
            현재 가지고 계신 토큰이 사라져요!
          </p>
        </section>

        {/* 토큰 박스 */}
        <section className="text-center pt-[40px]">
          <div className="rounded-[16px] border border-border-default bg-surface-light-white-layered p-[16px]">
            <p className="text-b1 text-text-subtle pb-[8px]">
              AI 이미지 생성 토큰
            </p>
            <div className="flex items-baseline justify-center gap-[8px] text-t2">
              <span className="leading-[38px] text-text-default">
                {tokenAmount}개
              </span>
              <span className="text-text-danger">
                즉시 소멸
              </span>
            </div>
          </div>
        </section>

        {/* 이모지 & 안내 타이틀 */}
        <section className="text-t4 text-text-default flex flex-col items-center pt-[80px]">
          <img src={cry} alt="crying emoji" />
          <p className="pt-[40px]">
            잠깐! 정말 마지막!
          </p>
          <p>
            탈퇴하기 전에 아래 정보를 확인해 주세요
          </p>
        </section>

        {/* 안내 카드 4줄 */}
        <section className="pt-[40px]">
          <div className=" px-[16px] py-[12px] space-y-[20px] bg-surface-light-subtle rounded-[16px]">
            <div>
              <p className="text-c1 text-text-subtle mb-[6px]">
                계정과 이용 내역은 삭제돼요
              </p>
              <p className="text-c2 text-text-subtler">
                회원님의 계정 정보, 매장 연동 정보, 이용 내역은 모두 삭제되며, 이후에는 복구되지 않아요.
              </p>
            </div>

            <div>
              <p className="text-c1 text-text-subtle mb-[6px]">
                보유 토큰들이 사라져요
              </p>
              <p className="text-c2 text-text-subtler">
                탈퇴 시점에 사용하지 않은 토큰은 자동으로 소멸되며, 재가입하셔도 복구되지 않아요.
              </p>
            </div>

            <div>
              <p className="text-c1 text-text-subtle mb-[6px]">
                처음부터 다시 가입해야 해요
              </p>
              <p className="text-c2 text-text-subtler">
                관련 법령에서 보존이 필요한 최소한의 정보(결제·거래 기록 등)를 제외하고는 모든 
                개인정보가 즉시 파기되기 때문에, 다시 가입하실 경우 처음부터 절차를 진행해야 해요.
              </p>
            </div>
          </div>
        </section>

        {/* 체크박스 + 텍스트 */}
        <section className="pt-[32px]">
          <button
            type="button"
            onClick={() => setAgreed((v) => !v)}
            className="flex items-center gap-[4px] w-full"
          >
            <span className="flex-shrink-0">
              <img
                src={agreed ? checkOn : checkOff}
                alt={agreed ? "checked" : "unchecked"}
                className="w-[24px] h-[24px]"
              />
            </span>
            <span className="text-b1 text-text-subtle text-left">
              (필수) 위 내용을 모두 숙지했고, 탈퇴에 동의합니다
            </span>
          </button>
        </section>
      </div>



      {/* 하단 버튼들 */}
      <SplitRowHalf
        leftText="더 써볼래요"
        onLeft={handleBack}
        rightText="떠날래요"
        onRight={handleLeave}
        leftType="border"
        rightType={agreed ? "alert" : "gray"}
        rightDisabled={!agreed}
      />
    </div>
  );
};

export default CancelUser;
